<template>
  <div>
    <template v-if="!storeState.gotBlock">
      <v-row class="pt-5">
        <v-col cols="12" sm="12" class="text-center pt-5">
          <v-progress-circular
            indeterminate
            :size="100"
            :width="8"
            color="primary"
            class="justify-center align-center"
          >
          </v-progress-circular>
        </v-col>
      </v-row>
    </template>
    <template v-else-if="storeState.noAccess">
      <div class="no-access">
        <h4> You don't have access to this block 😢, contact your team admin to get it.
          <button @click="store.getHelp" class="btn-link"> Click here to get help.</button>
        </h4>
      </div>
      <div class="no-access">
        <h4> You can also <button @click="newBlock" class="btn-link"> create your own block here</button>
        </h4>
      </div>
    </template>
    <div v-else ref="sets">
      <div class="sidebar-menu-icon-container">
        <v-icon @click="showSidebar=true">mdi-menu</v-icon>
      </div>
      <div class="sidebar-menu-container">
        <v-navigation-drawer
          v-model="showSidebar"
          :expand-on-hover="false"
          width="500"
          absolute
        >
          <v-list
            dense
            nav
            class="py-0"
          >
            <v-row>
              <v-col cols="12" sm="2" md="2" class="text-left clickable" @click="storeState.cmdkActive=true;showSidebar=false;">
                <v-avatar>
                  <img :src="storeState.settings.user.me.pic">
                </v-avatar>
              </v-col>
              <v-col cols="12" sm="8" md="8" class="text-left clickable" @click="storeState.cmdkActive=true;showSidebar=false;">
                <div>{{storeState.settings.user.me.email}}</div>
                <div>{{storeState.settings.user.me.name}}</div>
              </v-col>
              <v-col cols="12" sm="2" md="2" class="text-right clickable" @click="showSidebar=false;">
                <v-icon large>mdi-chevron-left</v-icon>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <div>
              <v-row 
                no-gutters 
                class="block-detail-row"
              >
                <v-col cols="12" sm="2" md="2">
                  <div class="auto-prepend-label">
                    <v-icon small class="dest-type-icon">mdi-database</v-icon>
                    Source
                  </div>
                </v-col>
                <v-col cols="12" sm="10" md="10" class="pad-col-left">
                  <v-autocomplete
                    ref="source"
                    v-model="storeState.block.source.uuid"
                    :items="uniqueSources"
                    placeholder="Postgres"
                    item-text="name"
                    item-value="block_uuid"
                    auto-select-first
                    single-line
                    dense
                    autocomplete="disabled"
                    class="denser"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <!-- {{item.name}} -->
                        <v-list-item-title v-html="item.name">{{item}}</v-list-item-title>
                        <v-list-item-subtitle v-html="item.db_type"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                    <template v-slot:append-item>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn text @click="editSources">Edit / remove sources</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row v-if="!editDestination" no-gutters class="block-detail-row" 
                @mouseover="hoverDestination=true" @mouseleave="hoverDestination=false">
                <v-col cols="12" sm="2" md="2">
                  <v-select
                    v-model="storeState.block.destination.type"
                    :items="storeState.destinationTypes"
                    label=""
                    dense
                    class="denser"
                  > 
                    <template v-slot:selection="data">
                      <div :data-type="data.item.value" class="clickable destination-type">
                        <v-icon small style="margin-top: -2px;" class="dest-type-icon">{{data.item.icon}}</v-icon>
                        <strong class="dest-type-label">{{data.item.text}}</strong>
                      </div>
                    </template>
                    <template v-slot:item="data">
                      <div :data-type="data.item.value" class="clickable destination-type">
                        <v-icon small>{{data.item.icon}}</v-icon>
                        <strong class="dest-type-label">{{data.item.text}}</strong>
                      </div>
                    </template>
                  </v-select>
                </v-col>
                <v-col @click="editDestination = true" cols="12" sm="8" md="8" class="pad-col-left clickable pad-top5">
                  <span class="sw-blue" v-html="store.getDestinationSummary(storeState.block)"></span>
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="hoverDestination">
                  <button @click="editDestination = true" class="soup-btn pad-btn right">
                    <v-icon>mdi-pencil</v-icon>
                  </button>
                  <button storeState.block.destination.type @click="openSheet" class="soup-btn right" v-if="storeState.block.destination.type === 'sheets'">
                    <v-icon>mdi-open-in-new</v-icon>
                  </button>
                </v-col>
              </v-row>
              <v-row v-if="editDestination" no-gutters class="block-detail-row">
                <v-col cols="12" sm="2" md="2">
                  <v-select
                    v-model="storeState.block.destination.type"
                    :items="storeState.destinationTypes"
                    label=""
                    dense
                    class="denser"
                  > 
                    <template v-slot:selection="data">
                      <div :data-type="data.item.value" class="clickable destination-type">
                        <v-icon small style="margin-top: -2px;" class="dest-type-icon">{{data.item.icon}}</v-icon>
                        <strong class="dest-type-label">{{data.item.text}}</strong>
                      </div>
                    </template>
                    <template v-slot:item="data">
                      <div :data-type="data.item.value" class="clickable destination-type">
                        <v-icon small>{{data.item.icon}}</v-icon>
                        <strong class="dest-type-label">{{data.item.text}}</strong>
                      </div>
                    </template>
                  </v-select>
                </v-col>
                <v-col v-if="storeState.block.destination.type === 'sheets' && !storeState.gotSheets" cols="12" sm="8" md="8" class="pad-col-left pad-top5">
                  No sheets
                </v-col>
                <v-col v-if="storeState.block.destination.type === 'sheets' && storeState.gotSheets" cols="12" sm="4" md="4" class="pad-col-left pad-top5">
                  <v-autocomplete
                    ref="spreadSheets"
                    v-model="storeState.block.destination.ss_id"
                    :items="storeState.destinations.spreadSheets"
                    placeholder="Spreadsheet"
                    item-text="name"
                    item-value="id"
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                    @change="onSpreadSheetChange"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn @click="refreshSpreadSheets" text>Refresh</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col v-if="storeState.block.destination.type === 'sheets' && storeState.gotSheets" cols="12" sm="3" md="3" class="pad-top5">
                  <v-autocomplete
                    v-model="storeState.block.destination.sheet"
                    :items="storeState.destinations.sheets"
                    :search-input.sync="searchSheet"
                    placeholder="Sheet1"
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                    :loading="loadingSheets"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title v-if="!loadingSheets">
                          <v-btn @click="addSheet" text>"<strong>{{ searchSheet }}</strong>" does not exist, add it?</v-btn>
                        </v-list-item-title>
                        <v-list-item-title v-else>
                          <v-progress-circular
                            indeterminate
                            :size="20"
                            :width="5"
                            color="primary"
                            class="justify-center align-center"
                          > 
                          </v-progress-circular> Loading
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col v-if="storeState.block.destination.type === 'sheets' && storeState.gotSheets" cols="12" sm="1" md="1" class="pad-top5">
                  <v-text-field
                    v-model="storeState.block.destination.cell"
                    placeholder="Cell (A1)"
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                  >
                  </v-text-field>
                </v-col>
                <v-col v-if="storeState.block.destination.type === 'slack'" cols="12" sm="8" md="8" class="pad-col-left">
                  <v-autocomplete
                    ref="spreadSheets"
                    v-model="storeState.block.destination.channel"
                    :items="storeState.destinations.slack.channels.channels"
                    placeholder="Channel"
                    item-text="name"
                    item-value="name"
                    auto-select-first
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn text>Loading</v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col v-if="storeState.block.destination.type === 'sync'" cols="12" sm="3" md="3" class="pad-col-left">
                  <v-autocomplete
                    ref="table"
                    v-model="storeState.block.destination.table"
                    :items="dbTables"
                    :search-input.sync="searchTable"
                    placeholder="Table"
                    item-text="name"
                    item-value="name"
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title v-if="!loadingMeta">
                          <v-btn @click="addTable" text>"<strong>{{ searchTable }}</strong>" not found, refresh database?</v-btn>
                        </v-list-item-title>
                        <v-list-item-title v-else>
                          <v-progress-circular
                            indeterminate
                            :size="20"
                            :width="5"
                            color="primary"
                            class="justify-center align-center"
                          > 
                          </v-progress-circular> Loading
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col v-if="storeState.block.destination.type === 'sync'" cols="12" sm="3" md="3">
                  <v-autocomplete
                    ref="table"
                    v-model="storeState.block.destination.primaryKey"
                    :items="dbPrimaryKeys"
                    :search-input.sync="searchPrimaryKey"
                    placeholder="Primary Key"
                    item-text="name"
                    item-value="name"
                    single-line
                    dense
                    autocomplete="off"
                    class="denser"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title v-if="!loadingMeta">
                          <span>"<strong>{{ searchPrimaryKey }}</strong>" does not exist</span>
                        </v-list-item-title>
                        <v-list-item-title v-else>
                          <v-progress-circular
                            indeterminate
                            :size="20"
                            :width="5"
                            color="primary"
                            class="justify-center align-center"
                          > 
                          </v-progress-circular> Loading
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col v-if="storeState.block.destination.type === 'sync'" cols="12" sm="2" md="2">
                  <v-checkbox
                    v-model="storeState.block.destination.isAutoIncrement"
                    label="Auto"
                    dense
                    small
                    class="denser" 
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                  <button @click="editDestination = false" class="soup-btn pad-btn right">
                    <v-icon>mdi-check</v-icon>
                  </button>
                  <button @click="clearDestination" class="soup-btn right">
                    <v-icon>mdi-close</v-icon>
                  </button>
                </v-col>
              </v-row>
              <v-row v-if="showDestination && editRepeat" no-gutters class="block-detail-row" style="padding-top:4px;">
                <v-col cols="12" sm="2" md="2">
                  <div class="auto-prepend-label">
                    <v-icon small class="dest-type-icon">mdi-update</v-icon>
                    Repeat
                  </div>
                </v-col>
                <v-col cols="12" sm="3" md="3" class="pad-col-left">
                  <v-select
                    ref="repeatPeriod"
                    :items="storeState.intervals"
                    v-model="storeState.block.repeat.period"
                    placeholder="Every"
                    single-line
                    dense
                    class="denser"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <v-text-field
                    v-if="storeState.block.repeat.period === 'hourly'"
                    placeholder="Minutes past"
                    v-model="storeState.block.repeat.minutesPast"
                    single-line
                    dense
                    class="denser"
                  ></v-text-field>
                  <div v-if="['daily', 'weekly'].includes(storeState.block.repeat.period)">
                    <v-select
                      placeholder="Time"
                      :items="runTimes"
                      v-model="storeState.block.repeat.runTime"
                      single-line
                      dense
                      class="denser run-time"
                    ></v-select> 
                    <a id = "utcTime" href="https://www.google.com/search?q=utc+time+converter" target="_blank">UTC</a>
                  </div>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                  <div v-if="storeState.block.repeat.period === 'weekly'">
                    <v-select
                      placeholder="Day"
                      :items="daysOfWeek"
                      v-model="storeState.block.repeat.dayOfWeek"
                      single-line
                      dense
                      class="denser run-time"
                    ></v-select> 
                  </div>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                  <button @click="editRepeat = false" class="soup-btn right pad-btn">
                    <v-icon>mdi-check</v-icon>
                  </button>
                  <button @click="clearRepeat" class="soup-btn right">
                    <v-icon>mdi-close</v-icon>
                  </button>
                </v-col>
              </v-row>
              <v-row v-if="showDestination && !editRepeat" no-gutters class="block-detail-row" style="padding-top:4px;"
                @mouseover="hoverRepeat=true" @mouseleave="hoverRepeat=false">
                <v-col cols="12" sm="2" md="2">
                  <div class="auto-prepend-label">
                    <v-icon small class="dest-type-icon">mdi-update</v-icon>
                    Repeat
                  </div>
                </v-col>
                <v-col @click="editRepeat = true" cols="12" sm="8" md="8" class="pad-col-left clickable">
                  {{getRepeat(storeState.block.repeat)}}
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="hoverRepeat">
                  <button @click="editRepeat = true" class="soup-btn right pad-btn">
                    <v-icon>mdi-pencil</v-icon>
                  </button>
                  <button @click="clearRepeat" class="soup-btn right">
                    <v-icon>mdi-close</v-icon>
                  </button>
                </v-col>
              </v-row>
              <!-- TAGSSSSSSSSSSS -->
              <v-row v-if="showDestination" no-gutters class="block-detail-row" style="padding-top:4px;">
                <v-col cols="12" sm="2" md="2">
                  <div class="auto-prepend-label">
                    <v-icon small class="dest-type-icon">mdi-tag</v-icon>
                    Tags
                  </div>
                </v-col>
                <v-col cols="12" sm="8" md="8" class="pad-col-left">
                  <template>
                    <v-combobox
                      ref="tagCombobox"
                      v-model="storeState.block.tags"
                      :items="storeState.blockTags"
                      chips
                      label="e.g. revenue"
                      multiple
                      single-line
                      auto-select-first
                      hide-selected
                      :rules="tagRules"
                      :search-input.sync="tagInput"
                      append-icon=''
                      @keyup.native.enter="tagAddedEnter()"
                      dense
                      class="denser"
                    >
                      <template v-slot:selection="{ attrs, item, select, selected }">
                        <v-chip
                          v-bind="attrs"
                          :input-value="selected.text"
                          close
                          dense
                          close-icon="mdi-close"
                          label
                          @click="selectTag"
                          @click:close="removeTag(item)"
                        >
                          {{ item.text }}
                        </v-chip>
                      </template>
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              No existing tags for "<strong>{{ tagInput }}</strong>" <v-btn class="create-tag" @click="createTag(tagInput)">create one?</v-btn>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-combobox>
                  </template>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                </v-col>
              </v-row>
            </div>
          </v-list>
          <div class="pt-3">
            <div
              :data-uuid="row.suggestionUuid"
              :ref="'suggestion_' + index"
              :id="'suggestion_' + index"
              v-for="(row, index) in storeState.sets"
              :key="row.suggestionUuid"
              :class="{
                  'row-hover': true,
                  'clickable': true,
                  'pl-3': true,
                  'pt-1': true,
                  'pb-1': true,
                  }"
              @click="goToSetJson(row.setJsonId)"
              >
              {{row.name}}
            </div>
          </div>
        </v-navigation-drawer>
      </div>
      <div class="search-container2">
        <div class="search-underlay">
          <div v-html="underlay"></div>
        </div>
        <div class="search-text-container">
          <textarea 
            placeholder="Search" 
            ref="searchText" 
            v-model="storeState.block.setQuery" 
            v-on:keyup="search"
            rows="1" 
            wrap="off" 
            class="search-text mousetrap" 
            spellcheck="false"
          >
          </textarea>
          <v-tooltip left dark color="#333">
            <template v-slot:activator="{ on }">
              <span v-on="on" class="save-search">
                <v-btn icon @click="runSet">
                  <v-icon large>
                    mdi-play-circle-outline
                  </v-icon>
                </v-btn>
              </span>
            </template>
            <span class="tooltip-text">Run</span>
            <span class="key">
              <span v-if="storeState.isMac" class="key-inner key-inner-icon">
                <v-icon color="#fff !important" size="12">mdi-apple-keyboard-command</v-icon>
              </span>
              <span v-else class="key-inner">
                Ctrl
              </span>
            </span>
            <span class="key">
              <span class="key-inner">Enter</span>
            </span>
          </v-tooltip>
        </div>
      </div>
      <div ref="searchSuggestions" class="search-suggestions" v-if="showSuggestions && storeState.searchTerm.length > 0">
        <div v-if="storeState.searchSuggestions.length === 0" class="suggest-explain">
          Find a dimension or measure from a Set
        </div>
        <div ref="suggestionList" v-if="storeState.searchTerm.length > 0">
          <div
            :data-uuid="row.suggestionUuid"
            :ref="'suggestion_' + index"
            :id="'suggestion_' + index"
            v-for="(row, index) in storeState.searchSuggestions"
            :key="row.suggestionUuid"
            @mouseover="hoverRow(row, index, true)"
            @mouseleave="hoverRow(row, index, false)"
            :class="{
                'active': (index === storeState.searchIndex), 
                'row-hover': storeState.searchIndex < 0,
                'searchResultRows': true,
                }"
            >
            <v-row>
              <v-col cols="12" sm="4" class="text-left dense-col clickable suggest-title" @click="rowClick" :data-uuid="row.uuid" :data-type="row.type" :data-index="index">
                <v-icon small class="blocks-icon left suggestion-icons">{{ row.icon }}</v-icon>
                <text-highlight :queries="storeState.searchTerm">{{row.title}}</text-highlight>
              </v-col>
              <v-col cols="12" sm="8" class="text-left dense-col clickable" @click="rowClick" :data-uuid="row.uuid" :data-type="row.type" :data-index="index">
                {{row.details}}
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
      <!-- <v-divider v-if="showSuggestions"></v-divider> -->
      <div class="io-split-container">
        <div class="split-elements">
          <div class="split-element" @click="showTableNow">
            <v-icon>mdi-table</v-icon>
            <span class="pl-2">Table</span> 
          </div>
          <div class="split-element" @click="showChartNow">
            <v-icon>mdi-poll-box</v-icon>
            <span class="pl-2">Chart</span>
          </div>
          <div class="split-element-right">
            <div ref="filterBtn" class="clickable inline" @click="showFiltersNow" 
              v-closabletwo="{
                exclude: ['filterList'],
                handler: 'hideFilters'
              }"
            >
              <v-icon :class="{'sw-blue': storeState.block.set.filters.length > 0}">mdi-filter</v-icon>
              <span :class="{'sw-blue': storeState.block.set.filters.length > 0}">Filter ({{storeState.block.set.filters.length}})</span>
            </div>
            <div ref="filterList" class="query-filters" v-if="showFilters">
              <div>
                <div
                  v-for="(filter, index) in storeState.block.set.filters"
                  :key="index"
                >
                  <v-row class="filter-row">
                    <v-col cols="12" sm="1" md="1" class="pr-0" v-if="index > 0">
                      <v-select
                        :items="andOr"
                        v-model="storeState.block.set.filters[index].andOr"
                        placeholder="And"
                        single-line
                        dense
                        class="denser"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="12" :sm="index > 0 ? 4 : 5" :md="index > 0 ? 4 : 5" class="">
                      <v-select
                        v-model="storeState.block.set.filters[index].field"
                        :items="filterSuggestions"
                        placeholder="Field"
                        item-value="path"
                        return-object
                        auto-select-first
                        single-line
                        autocomplete="disabled"
                        dense
                        class="denser"
                        @change="onFilterFieldChange"
                      >
                        <template v-slot:item="{ item }">
                          <v-list-item-content>
                            <v-list-item-title>
                              <v-icon>{{item.icon}}</v-icon>
                              <span class="pl-1">{{item.path}}</span>
                            </v-list-item-title>
                          </v-list-item-content>
                        </template>
                        <template v-slot:selection="{ item }">
                          <div>
                            <v-icon>{{item.icon}}</v-icon>
                            {{item.path}}
                          </div>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="2" md="2" class="">
                      <v-select
                        :items="tableFilterOperators[index]"
                        v-model="storeState.block.set.filters[index].operator"
                        item-value="key"
                        item-text="display"
                        placeholder="Operator"
                        return-object
                        single-line
                        dense
                        class="denser"
                        autocomplete="disabled"
                        @change="onFilterOperatorChange"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" class="" v-if="storeState.block.set.filters[index].operator.dateNlp">
                      <v-autocomplete
                        v-model="storeState.block.set.filters[index].value"
                        :items="storeState.block.set.filters[index].dateNlpSuggestions"
                        :search-input.sync="dateNlpSearch"
                        :filter="customDataNlpAutoFilter"
                        placeholder="Time"
                        single-line
                        dense
                        class="denser"
                        autocomplete="disabled"
                        v-on:keyup="getDateNlpSuggestions(index)"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" class="" v-else-if="storeState.block.set.filters[index].operator.period">
                      <v-autocomplete
                        v-model="storeState.block.set.filters[index].value"
                        :items="storeState.block.set.filters[index].dateNlpSuggestions"
                        :search-input.sync="dateNlpSearch"
                        :filter="customDataNlpAutoFilter"
                        placeholder="Time"
                        single-line
                        dense
                        class="denser"
                        autocomplete="disabled"
                        return-object
                        v-on:keyup="getDatePeriodSuggestions(index)"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" class="" v-else-if="!noValueOperators.includes(storeState.block.set.filters[index].operator)">
                      <v-text-field
                        v-model="storeState.block.set.filters[index].value"
                        placeholder="Value"
                        single-line
                        dense
                        class="denser"
                        autocomplete="disabled"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="1" md="1" class="">
                      <v-icon @click="removeFilter(index)">mdi-close</v-icon>
                    </v-col>
                  </v-row>
                </div>
                <v-row class="filter-row clickable row-highlight" @click="addFilter">
                  <div >
                    <v-icon>mdi-plus</v-icon>
                    <span class="pad-span-left">Add filter</span>
                  </div>
                </v-row>
                <v-row class="filter-row clickable row-highlight" @click="applyFilters">
                  <div >
                    <v-icon>mdi-play</v-icon>
                    <span class="pad-span-left">Apply filters</span>
                  </div>
                </v-row>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="search-table-container" v-if="showTable">
        <v-data-table
          v-if="storeState.block.results && !storeState.tableLoading"
          fixed-header
          :hide-default-header="true"
          :show-expand="false"
          single-expand
          :headers="storeState.block.results.headers"
          :items="storeState.block.results.rows"
          :items-per-page="100"
          :loading="storeState.tableLoading"
          :options.sync="storeState.block.results.tableOptions"
        >
          <template v-slot:header="props">
            <thead class="v-data-table-header">
              <tr>
                <th
                  v-for="(header, index) in storeState.block.results.headers"
                  :key="index"
                  @click="changeSort(header.value)"
                  class="clickable"
                  @contextmenu.prevent="showContextMenuHeader"
                  :data-header-index="index"
                >
                  <!-- <v-icon small class="header-icon">{{ getHeaderIcon(header) }} </v-icon> -->
                  <v-icon small class="header-icon">{{ storeState.iconLookUp[header.dtype] }} </v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </thead>
          </template>
          <template slot="progress"></template>
          <template v-slot:no-data>
            No results
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">{{store.filterObject(item)}}</td>
          </template>
          <template slot="loading">
          </template>
          <!-- <v-pagination v-model="page" :length="pageCount"></v-pagination> -->
        </v-data-table>
        <div v-if="storeState.tableLoading" class="fetching-msg-container">
        <!-- <div v-if="true" class="fetching-msg-container"> -->
          <v-row>
            <v-col class="text-center">
              <div class="dot-pulse-container">
                <div class="dot-pulse"></div> 
              </div>
              <!-- <span class="fetching-msg-code">{{storeState.block.code.slice(0, 200)}}</span> -->
            </v-col>
          </v-row>
        </div>
      </div>
      <div class="chart-container" v-if="showChart">
        <v-row>
          <v-col cols="12" sm="8" class="text-center">
            <div class="text-left pl-5 pt-3">
              <input class="chart-title" ref="chartTitle" v-model="storeState.block.viz.title" placeholder="Untitled">
            </div>
            <template>
              <div v-if="chartReady" class="small-chart">
                <line-chart 
                  v-if="storeState.block.viz.type === 'line' && storeState.block.viz.datacollection" 
                  :chart-data="storeState.block.viz.datacollection" 
                  :options="storeState.block.viz.chartJsOptions"
                  :styles="chartStyles"
                  >
                </line-chart>
                <bar-chart 
                  v-else-if="storeState.block.viz.type === 'bar' && storeState.block.viz.datacollection" 
                  :chart-data="storeState.block.viz.datacollection" 
                  :options="storeState.block.viz.chartJsOptions"
                  :styles="chartStyles"
                  >
                </bar-chart>
              </div>
            </template>
          </v-col>
          <v-col cols="12" sm="4" class="text-center">
            <v-row class="viz-row">
              <v-col cols="12" sm="12" class="text-left">
                <v-select
                :items="storeState.vizOptions.types"
                v-model="storeState.block.viz.type"
                label=""
                > 
                  <template v-slot:selection="data">
                    <div :data-type="data.item.value" class="clickable destination-type">
                      <v-icon small style="margin-top: -2px;" class="dest-type-icon">{{data.item.icon}}</v-icon>
                      <strong class="chart-option-label">{{data.item.label}}</strong>
                    </div>
                  </template>
                  <template v-slot:item="data">
                    <div :data-type="data.item.value" class="clickable destination-type">
                      <v-icon small>{{data.item.icon}}</v-icon>
                      <strong class="chart-option-label">{{data.item.label}}</strong>
                    </div>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" class="text-left">
                <span class=""></span>
                <strong>Dimensions</strong>
              </v-col>
            </v-row>
            <v-row 
              v-for="(row, index) in storeState.block.setQueryThings.filter(t => (!t.measure && t.label))"
              :key="row.suggestionUuid"
              @click="vizRowClick(row)"
              class="viz-row"
            >
              <v-col cols="12" sm="12" class="text-left clickable">
                <v-icon small style="margin-top: -2px;">{{getTypeIcon(row)}}</v-icon>
                <span :class="{'pl-2': true, 'viz-selected': row.selected}">{{row.label}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" class="text-left">
                <span class=""></span>
                <strong>Measures</strong>
              </v-col>
            </v-row>
            <v-row 
              v-for="(row, index) in storeState.block.setQueryThings.filter(t => t.measure)"
              :key="row.suggestionUuid"
              @click="vizRowClick(row)"
              class="viz-row"
            >
              <v-col cols="12" sm="12" class="text-left clickable">
                <v-icon small style="margin-top: -2px;">{{getTypeIcon(row)}}</v-icon>
                <span :class="{'pl-2': true, 'viz-selected': row.selected}">{{row.label}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" class="text-left">
                <span class=""></span>
                <strong>Options</strong>
              </v-col>
            </v-row>
            <v-row 
              class="viz-row"
            >
              <v-col cols="12" sm="12" class="text-left clickable">
                <v-select
                :items="storeState.vizOptions.legends"
                v-model="storeState.block.viz.chartJsOptions.legend"
                return-object
                label=""
                > 
                  <template v-slot:selection="data">
                    <div :data-type="data.item.value" class="clickable destination-type">
                      <v-icon small>{{data.item.icon}}</v-icon>
                      <span class="pl-2">{{data.item.label}}</span>
                    </div>
                  </template>
                  <template v-slot:item="data">
                    <div :data-type="data.item.value" class="clickable destination-type">
                      <v-icon small>{{data.item.icon}}</v-icon>
                      <span class="pl-2">{{data.item.label}}</span>
                    </div>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row 
              @click="flipStacked()"
              class="viz-row"
            >
              <v-col cols="12" sm="12" class="text-left clickable">
                <v-icon small style="margin-top: -2px;">{{storeState.block.viz.stacked ? 'mdi-chart-bar-stacked' : 'mdi-chart-bar'}}</v-icon>
                <span :class="{'pl-2': true}">{{storeState.block.viz.stacked ? 'Stacked' : 'Grouped'}}</span>
              </v-col>
            </v-row>
            <v-row 
              @click="flipFill()"
              class="viz-row"
              v-if="storeState.block.viz.type === 'line'"
            >
              <v-col cols="12" sm="12" class="text-left clickable">
                <v-icon small style="margin-top: -2px;">{{storeState.block.viz.fill ? 'mdi-chart-bar-stacked' : 'mdi-chart-bar'}}</v-icon>
                <span :class="{'pl-2': true}">{{storeState.block.viz.fill ? 'Fill' : 'No Fill'}}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <v-menu
        v-model="showContextMenu"
        :position-x="contextData.x"
        :position-y="contextData.y"
        absolute
        offset-y
      >
        <v-list>
          <v-list-item
            v-for="(item, index) in contextOptions"
            :key="index"
            @click="item.f()"
          >
            <v-list-item-title>
              <v-icon>{{item.icon}}</v-icon>
              <span class="pl-1">{{item.title}}</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <div v-if="false">
        <pre>this.storeState.block {{store.makeBlockSafe(storeState.block)}}</pre>
        <pre>underlay {{underlay}}</pre>
        <pre>this.storeState.block.setQueryThings {{storeState.block.setQueryThings}}</pre>
        
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import debounce from 'debounce';
import { store } from '../store.js';
import draggable from 'vuedraggable';
import _ from 'lodash';
import LineChart from './LineChart.js'
import BarChart from './BarChart.js'
import TextHighlight from 'vue-text-highlight';
var chrono = require('chrono-node');


export default {
  mounted() {
    window.bus.$on('focusEl', (details) => {
      setTimeout(() => {
        let ref = this.$refs[details.el]
        if (ref) ref.focus()
      }, 0);
    });
    
    setTimeout(() => {
      if (this.$refs.searchText) this.$refs.searchText.focus()
    }, 0);
  },
  data() {
    return {
      storeState: store.state,
      chartStyles: {
        height: '400px',
        width: '100%',
        position: 'relative',
      },
      chartReady: false,
      hoverRepeat: false,
      editRepeat: false,
      editDestination: false,
      hoverDestination: false,
      showDestination: true,
      loadingSheets: false,
      searchSheet: null,
      searchTable: null,
      searchPrimaryKey: null,
      tagInput: '',
      tagRules: [
        v => false
      ],
      editingTag: false,
      showContextMenu: false,
      contextData: {},
      contextOptions: [],
      dateNlpSearch: '',
      linkColor: 'color: rgb(46, 170, 220)',
      iconLookUp: {
        number: 'mdi-numeric',
        string: 'mdi-format-text',
        date: 'mdi-calendar-blank',
        time: 'mdi-calendar-blank',
      },
      noValueOperators: ['isNotNull', 'isNull'],
      filterSuggestions: [],
      filterOperators: {
        number: [
          {display: '=', sql: '$field = $value', text: 'Equal to', key: 'equalTo'},
          {display: '≠', sql: '!=', text: 'Not equal to', key: 'notEqualTo'},
          {display: '≥', sql: '>=', text: 'Greater than or equal to', key: 'gte'},
          {display: '≤', sql: '<=', text: 'Less than or equal to', key: 'lte'},
          {display: '>', sql: '>', text: 'Greater than', key: 'gt'},
          {display: '<', sql: '<', text: 'Less than', key: 'lt'},
          {display: 'Null', sql: 'IS NULL', text: 'Null', key: 'isNull'},
          {display: 'Not Null', sql: 'IS NOT NULL', text: 'Not Null', key: 'isNotNull'},
        ],
        string: [
          {display: 'Is', sql: '=', text: 'Is', key: 'notNull'},
          {display: 'Is Not', sql: '!=', text: 'Is not', key: 'notNull'},
          {display: 'Contains', sql: `$field LIKE '%$value%'`, text: 'Contains', key: 'contains'},
          {display: 'Does not contain', sql: `$field NOT LIKE '%$value%'`, text: 'Contains', key: 'notContain'},
          {display: 'Starts With', sql: `$field LIKE '$value%'`, text: 'Contains', key: 'startsWith'},
          {display: 'Ends With', sql: `$field LIKE '%$value'`, text: 'Contains', key: 'endsWith'},
          {display: 'Is Null', sql: `$field IS NULL`, text: 'Is Null', key: 'isNull'},
          {display: 'Is Not Null', sql: '$field IS NOT NULL', text: 'Is Not Null', key: 'isNotNull'},
        ],
        time: [
          {display: 'Is', sql: `CAST($field AS DATE) = '$value'`, text: 'Is', key: 'exactDate', dateNlp: true},
          {display: 'Is in the past', sql: `$field > current_date - interval '$num' $period`, 
            text: 'Is', key: 'dateInThePast', dateNlp: false, period: true},
          {display: 'Is on or after', sql: `$field >= '$value'`, text: 'Is after', key: 'dateOnOrAfter', dateNlp: true},
          {display: 'Is after', sql: `$field > '$value'`, text: 'Is after', key: 'dateAfter', dateNlp: true},
          {display: 'Is on or before', sql: `$field <= '$value'`, text: 'Is after', key: 'dateOnOrBefore', dateNlp: true},
          {display: 'Is before', sql: `$field < '$value'`, text: 'Is after', key: 'dateBefore', dateNlp: true},
        ]
      },
      showSidebar: false,
      andOr: [
        {text: 'And', value: 'and'},
        {text: 'Or', value: 'or'},
      ],
      showFilters: false,
      // https://coolors.co/50514f-f25f5c-ffe066-247ba0-70c1b3
      defaultColorScheme: [
        {color: '#F25F5C', nickname: 'red', primary: true},
        {color: '#247BA0', nickname: 'blue', primary: true},
        {color: '#FFE066', nickname: 'yellow', primary: false},
        {color: '#70C1B3', nickname: 'green', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#fff', nickname: 'white', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
      ],
      showTable: true,
      showChart: false,
      showSql: false,
      store: store,
      searchTerm: store.state.searchTerm,
      showSuggestions: true,
      blockHoverIndex: -1,
      searching: store.state.searching,
      favorites: false,
      scheduled: false,
      searchResults: [],
      searchSuggestions: store.state.searchSuggestions,
      saved: false,
      underlay: '',
      tempSearch: '',
      newTag: '',
      tags: [],
    };
  },
  components: {
    draggable,
    LineChart,
    BarChart,
    TextHighlight,
  },
  watch: {
    'storeState.tableLoading': {
      handler: function (newVal, oldVal) {
        console.log('watch tableLoading', 'newval: ', newVal, '   oldVal:', oldVal)
        this.showSuggestions = false
        // if (!newVal) {
          
        // } 
      }
    },
    // 'storeState.block.viz.chartJsOptions': {
    //   handler: function (newVal, oldVal) {
    //     console.log('watch chart options', 'newval: ', newVal, '   oldVal:', oldVal)
    //     this.$forceUpdate()
    //   },
    //   deep: true,
    // },
    'storeState.block.title': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
          if (this.storeState.block.title && this.storeState.block.title.length > 0) {
            document.title = this.storeState.block.title;
          }
        },
        deep: false
    },
    'storeState.block.setQuery': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: false
    },
    'storeState.block.tags': {
        handler: function (val, oldVal) {
          console.log('storeState.block.tags: ', val, oldVal)
          var tags = []
          for (let [key, value] of Object.entries(this.storeState.blocks)) {
            let blockTagKeys = value.tags.map(t => t.value)
            let allTagKeys = tags.map(t => t.value)
            let newTags = _.difference(blockTagKeys, allTagKeys)
            if (newTags.length > 0 && newTags[0]) {
              for (let i = 0; i < newTags.length; i++) {
                tags.push(value.tags.find(t => t.value === newTags[i]))
              }
            }
          }
          this.storeState.blockTags = tags
          store.updateBlock({gotBlock: this.storeState.gotBlock})
          console.log('this.storeState.blockTags: ', this.storeState.blockTags)
        },
        deep: true,
    },
    'storeState.block.code': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.set.filters': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.destination': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.source': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.repeat': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.favorite': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        }
    },
    'storeState.block.params': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        }
    },
    'storeState.block.results.rows': {
        handler: function (val, oldVal) {
          if (this.storeState.block && this.storeState.block.results.rows.length > 0) {
            store.updateBlock({gotBlock: this.storeState.gotBlock})
            this.makeChart()
          }
        },
        deep: true
    },
    'storeState.block.viz': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
  },
  filters: {
    fromNowFilter: function (data) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${data.email}`]
      if (details.reminder) {
        let m = moment(details.reminder)
        return m.fromNow()
      } else {
        return ''
      }
    }
  },
  methods: {
    makeLabel(s) {
      return s.toLowerCase().split('_').map(s => s.charAt(0).toUpperCase() + s.slice(1)).toString().replace(',', ' ')
    },
    createTag(tag) {
      console.log(tag)
      this.storeState.addingTag = true
      this.storeState.cmdkParentCmd = 'createTag'
      this.$parent.openCmdK({cmdkParentCmd: 'createTag', cmdkInput: tag})
    },
    fromNowFormat: function (data) {
      return moment(data.viewedOn/1000).fromNow()
    },
    fromNowRunFormat: function (data) {
      return moment(data/1000).fromNow()
    },
    clearDestination() {
      this.storeState.block.destination = JSON.parse(JSON.stringify(this.storeState.blockTemplate.destination))
    },
    refreshSpreadSheets() {
      this.$parent.getSoupSheets()
    },
    sendToSheets() {
      this.showDestination = true
      this.editDestination = true
      this.$nextTick(this.$refs.spreadSheets.focus)
    },
    deleteBlock(block) {
      Vue.delete(this.storeState.blocks, block.uuid)
      store.deleteBlock(block)
    },
    focusSource() {
      this.$nextTick(this.$refs.source.focus)
    },
    clearRepeat() {
      this.storeState.block.repeat = JSON.parse(JSON.stringify(this.storeState.blockTemplate.repeat))
    },
    openSheet() {
      let url = store.getSheetUrl()
      const win = window.open(url, '_blank')
    },
    addSheet() {
      this.storeState.destinations.sheets.push(this.searchSheet)
    },
    getSheets() {
      const path = store.getPath('/soup_get_sheets')
      let d = {sessionId: this.storeState.sessionId, ss_id: this.storeState.block.destination.ss_id}
      var self = this
      axios.post(path, d)
        .then((res) => {
          console.log('got soup_get_sheets: ', res.data)
          if (!res.data.sheets) {
            this.storeState.snackbar = true;
            this.storeState.message = 'Error getting Sheets metadata';
            return
          }
          self.loadingSheets = false
          self.storeState.destinations.spreadSheetMetadata = res.data
          self.storeState.destinations.sheets = res.data.sheets.map(s => s.properties.title)
          self.$forceUpdate()
        })
        .catch((error) => {
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    onSpreadSheetChange(newVal) {
      console.log('onSpreadSheetChange', newVal)
      this.storeState.destinations.sheets = []
      this.loadingSheets = true
      this.getSheets()
    },
    getRepeat(repeat) {
      if (repeat.period === 'hourly') {
        return `Hourly at ${repeat.minutesPast} minutes past`
      } else if (repeat.period === 'daily') {
        return `Daily at ${repeat.runTime || ' not selected'}`
      } else if (repeat.period === 'weekly') {
        return `Weekly on ${repeat.dayOfWeek.replace(/^\w/, c => c.toUpperCase())} at ${repeat.runTime}`
      } else if (repeat.period === 'monthly') {
        return `Monthly`
      } else if (repeat.period === 'fivemin') {
        return `Every 5 minutes`
      }
      return `Click to set schedule`
    },
    showContextMenuHeader(e) {
      e.preventDefault()
      console.log('show context', e)
      this.contextOptions = [
        { title: 'Copy column name', icon: 'mdi-content-copy', f: this.copyColumnName },
        { title: 'View Definition', icon: 'mdi-code-tags', f: this.goToSetDefinition },
      ]
      let headerIndex = e.currentTarget.dataset.headerIndex || e.target.dataset.headerIndex
      let header = this.storeState.block.results.headers[Number(headerIndex)]
      this.contextData.header = header
      this.contextData.x = e.clientX
      this.contextData.y = e.clientY
      this.$nextTick(() => {
        this.showContextMenu = true
      })
    },
    copyColumnName() {
      this.$copyText(this.contextData.header.text)
      this.storeState.snackbar = true;
      this.storeState.message = `Copied ${this.contextData.header.text}`;
    },
    goToSetDefinition() {
      let blockId = this.storeState.block.setQueryThings[0].setJsonId
      let routeData = this.$router.resolve({ name: 'Run', params: {id: blockId }});
      window.open(routeData.href, '_blank');
    },
    hideFilters() {
      this.showFilters = false
    },
    getHeaderIcon(header) {
      this.storeState.block.setQueryThings.find(t => t.title === header.text).icon
    },
    runSet() {
      let opts = {setQueryThings: this.storeState.block.setQueryThings, filters: this.storeState.block.set.filters}
      let sql = store.generateSetSql(opts)
      this.storeState.block.code = sql
      this.showSuggestions = false
      this.showFilters = false
      this.storeState.searchSuggestions = []
      store.runSet({})
    },
    showFiltersNow()  {
      this.showFilters = !this.showFilters
      this.getFilterSuggestions()
      this.getFilterOperators()
      this.$forceUpdate()
    },
    applyFilters() {
      // let sql = store.generateSetSql(this.storeState.block.tables)
      let opts = {setQueryThings: this.storeState.block.setQueryThings, filters: this.storeState.block.set.filters}
      let sql = store.generateSetSql(opts)
      this.storeState.block.code = sql
      this.showSuggestions = false
      this.showFilters = false
      this.storeState.searchSuggestions = []
      store.runSet({})
    },
    onFilterFieldChange() {
      this.getFilterOperators()
    },
    onFilterOperatorChange() {
    },
    getFilterOperators() {
      console.log('getFilterOperators...')
      if (!this.storeState.block.tables) return
      this.tableFilterOperators = []
      for (let i = 0; i < this.storeState.block.set.filters.length; i++) {
        let filter = this.storeState.block.set.filters[i];
        if (!filter.field.type) {
          this.tableFilterOperators[i] = this.filterOperators['string']
        } else {
          this.tableFilterOperators[i] = this.filterOperators[filter.field.type]
        }
      }
      this.$forceUpdate()
    },
    customDataNlpAutoFilter() {
      return true
    },
    getDateNlpSuggestions(index) {
      console.log('getDateNlpSuggestions...')
      let filters = this.storeState.block.set.filters[index]
      var opt = {text: `e.g. "3 days ago"`, value: 'asdfasdf'}
      var parsedDate = chrono.parseDate(this.dateNlpSearch)
      if (parsedDate) {
        console.log('getDateNlpSuggestions...', parsedDate, parsedDate.toDateString())
        let sqlDate = parsedDate.toJSON().replace('T', ' ').slice(0, 10)
        opt = {text: sqlDate, value: sqlDate}
        filters.dateNlpSuggestions = [opt]
        this.$set(this.storeState.block.set.filters, index, filters)
      } else {
        filters.dateNlpSuggestions = []
        let periods = ['days', 'weeks', 'months', 'years', 'hours', 'minutes']
        let exacts = ['yesterday', 'tomorrow', 'today', 'now', 'monday', 'tuesday']
        var includePeriods = []
        let searchParts = this.dateNlpSearch.split(' ')
        let nums = this.dateNlpSearch.match(/(\d+)/)
        var num = 1
        if (nums) num = nums[0]
        var hasYesteday = false
        var hasToday = false
        for (let i = 0; i < searchParts.length; i++) {
          let search = searchParts[i];
          for (let i2 = 0; i2 < periods.length; i2++) {
            let period = periods[i2];
            if (period.startsWith(search)) {
              let p = `${num} ${period} ago`
              var parsedDate = chrono.parseDate(p)
              if (parsedDate) {
                let sqlDate = parsedDate.toJSON().replace('T', ' ').slice(0, 10)
                opt = {text: p, value: sqlDate}
                filters.dateNlpSuggestions.push(opt)
              }
            }
          }
          for (let i2 = 0; i2 < exacts.length; i2++) {
            let exact = exacts[i2];
            if (exact.startsWith(search)) {
              var parsedDate = chrono.parseDate(exact)
              let sqlDate = parsedDate.toJSON().replace('T', ' ').slice(0, 10)
              opt = {text: exact, value: sqlDate}
              filters.dateNlpSuggestions.push(opt)
            }
          }
        }
        this.$set(this.storeState.block.set.filters, index, filters)
      }
    },
    getDatePeriodSuggestions(index) {
      console.log('getDatePeriodSuggestions...')
      let filters = this.storeState.block.set.filters[index]
      filters.dateNlpSuggestions = []
      let periods = ['days', 'months', 'years', 'hours', 'minutes']
      var includePeriods = []
      let searchParts = this.dateNlpSearch.split(' ')
      let nums = this.dateNlpSearch.match(/(\d+)/)
      var num = 1
      if (nums) num = nums[0]
      for (let i = 0; i < periods.length; i++) {
        let period = periods[i];
        for (let i2 = 0; i2 < searchParts.length; i2++) {
          let search = searchParts[i2];
          if (period.startsWith(search)) {
            includePeriods.push(period)
          }
        }
      }
      if (includePeriods.length === 0) includePeriods = periods
      for (let i = 0; i < includePeriods.length; i++) {
        let period = includePeriods[i];
        let opt = {text: `${num} ${period}`, value: `${num} ${period}`, num: num, period: period}
        filters.dateNlpSuggestions.push(opt)
      }
      this.$set(this.storeState.block.set.filters, index, filters)
    },
    changeSort(column) {
      if (this.storeState.block.results.tableOptions.sortBy === column) {
        let direction = !this.storeState.block.results.tableOptions.sortDesc
        this.storeState.block.results.tableOptions.sortDesc = direction
        // this.storeState.block.results.rows = this.storeState.block.results.rows.sort((a, b) => a[column] - b[column]);
        this.storeState.block.results.rows = _.orderBy(this.storeState.block.results.rows, [column], [(direction ? 'desc' : 'asc')]);
      } else {
        this.storeState.block.results.tableOptions.sortBy = column
        this.storeState.block.results.tableOptions.sortDesc = false
        // this.storeState.block.results.rows = this.storeState.block.results.rows.sort((a, b) => b[column] - a[column]);
        this.storeState.block.results.rows = _.orderBy(this.storeState.block.results.rows, [column], ['asc']);

      }
    },
    moment: function () {
      return moment();
    },
    goToSetJson(blockId) {
      let routeData = this.$router.resolve({ name: 'Run', params: {id: blockId }})
      window.open(routeData.href, '_blank');
    },
    editSources() {
      console.log('edit source...')
      this.$router.push({ name: 'Sources' }).catch(err => console.error(err))
    },
    getRandomInt () {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
    goToSql() {
      this.$router.push({ name: 'Run', params: {id: this.storeState.block.uuid }}).catch(err => console.error(err))
    },
    addFilter() {
      let filter = {
        andOr: false,
        field: '',
        operator: '=',
        value: '',
      }
      if (this.storeState.block.set.filters.length > 0) {
        filter.andOr = 'and'
      }
      this.storeState.block.set.filters.push(filter)
    },
    removeFilter(index) {
      this.storeState.block.set.filters.splice(index, 1)
      this.showFilters = true
    },
    flipStacked() {
      this.storeState.block.viz.stacked = !this.storeState.block.viz.stacked
      if (this.storeState.block.viz.stacked) {
        this.storeState.block.viz.chartJsOptions.scales = {
          xAxes: [{
              stacked: true
          }],
          yAxes: [{
              stacked: true
          }]
        }
      } else {
        this.storeState.block.viz.chartJsOptions.scales = {}
      }
      // this.$forceUpdate()
      this.makeChart()
    },
    flipFill() {
      this.storeState.block.viz.fill = !this.storeState.block.viz.fill
      // this.$forceUpdate()
      this.makeChart()
    },
    getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    getTypeIcon(row) {
      if (row.measure) return 'mdi-numeric'
      if (!row.type) return 'mdi-format-text'
      return this.storeState.iconLookUp[row.type]
    },
    vizRowClick(row) {
      let changed = this.storeState.block.setQueryThings.findIndex(q => q.suggestionUuid === row.suggestionUuid)
      this.storeState.block.setQueryThings[changed].selected = !this.storeState.block.setQueryThings[changed].selected
      this.makeChart()
      this.$forceUpdate()
    },
    showTableNow() {
      this.showTable = true
      this.showChart = false
    },
    showChartNow() {
      this.showTable = false
      this.showChart = true
    },
    getDimensionsMeasures(d) {
      let dimensions = []
      let measures = []
      if (this.storeState.block.setQueryThings.length === 1) {
        var allFields = this.getAllFieldsForSet(this.storeState.block.setQueryThings[0])
        this.storeState.block.setQueryThings = [...allFields, ...this.storeState.block.setQueryThings]
      }
      for (let [key, obj] of Object.entries(d[0])) {
        let setInfo = this.storeState.block.setQueryThings.find(t => t.label === key || t.name === key)
        if (!setInfo && key === 'Count') {
          console.log('found the count: ', )
          measures.push({
            "label": "Count",
            "measure": true,
            "type": "count",
            "data": []
          })
        } else if (!setInfo) {
          //do nothing
        } else if (setInfo.measure) {
          console.log('found measure: ', setInfo)
          setInfo.data = []
          measures.push(setInfo)
        } else {
          dimensions.push(setInfo)
        }
      }
      return {dimensions: dimensions, measures: measures}
    },
    getChartLabels(d, dm) {
      let rows = []
      for (let i = 0; i < d.length; i++) {
        let row = d[i];
        rows.push(row[dm.dimensions[0].label])
      }
      return rows
    },
    getChartData(d, dm) {
      let rows = []
      for (let i = 0; i < d.length; i++) {
        let row = d[i];
        // dm.measures[i].data = []
        for (let i2 = 0; i2 < dm.measures.length; i2++) {
          dm.measures[i2].data.push(row[dm.measures[i2].label])
        }
      }
      for (let i = 0; i < dm.measures.length; i++) {
        let el = dm.measures[i];
        if (el.selected) {
          var color = this.defaultColorScheme[i].color
          if (!color) color = this.getRandomColor()
          rows.push({
            label: el.label,
            backgroundColor: color,
            borderColor: color,
            data: el.data,
            fill: this.storeState.block.viz.fill
          })
        }
      }
      return rows
    },
    makeChart() {
      console.log('make chart')
      this.chartReady = false
      let dm = this.getDimensionsMeasures(this.storeState.block.results.rows)
      if (dm.dimensions.length === 0) return
      this.storeState.block.viz.datacollection = {
        labels: this.getChartLabels(this.storeState.block.results.rows, dm),
        datasets: this.getChartData(this.storeState.block.results.rows, dm),
      }
      this.chartReady = true
    },
    backToBlocks() {
      this.storeState.searching = false
      this.$router.push({ name: 'Blocks'}).catch(err => console.error(err))
    },
    getUserPic(email) {
      let u = this.storeState.settings.team.members.find(u => u.email === email)
      if (u) return u.pic
      return ''
    },
    fromNowRunFormat: function (data) {
      if (!data) return 'Never run'
      return moment(data/1000).fromNow()
    },
    deleteBlock(block) {
      Vue.delete(this.storeState.blocks, block.uuid)
      store.deleteBlock(block)
    },
    runBlock(block) {
      this.$parent.openBlock(block.uuid)
    },
    getSourceName(row) {
      let s = this.storeState.allSources.find(s => s.block_uuid === row.source.uuid)
      if (s && s.name) return `${s.name}`
      return ''
    },
    hoverRow(row, index, hover) {
      if (hover) {
        this.storeState.searchIndex = -1
        this.blockHoverIndex = index
      } else {
        this.storeState.searchIndex = -1
        this.blockHoverIndex = -1
      }
    },
    getBlock(uuid) {
      if (this.storeState.gotBlocks) {
        var block = this.storeState.blocks[uuid]
        if (block) {
          console.log('gotBlock: ', block)
          block.viewedOn = moment.unix(moment()).utc()._i
          block = store.addMissingBlockAttributes(block)
          this.storeState.block = block
          if (block.destination.sheet && this.storeState.destinations.sheets.length === 0) {
            this.storeState.destinations.sheets.push(block.destination.sheet)
          }
          // if (!this.storeState.block.source.uuid) {
          //   this.storeState.block.source.uuid = this.storeState.defaultSource.block_uuid
          // }
          this.getSearchSuggestions({searchTerm: ''})
          this.updateUnderlayKeydown()
          this.getFilterSuggestions()
          this.storeState.gotBlock = true
          setTimeout(() => {
            this.$refs.searchText.focus()
          }, 0);
          this.getBlockHistory()
        } else if (this.storeState.newBlocks.includes(uuid)) {
          this.storeState.block = JSON.parse(JSON.stringify(this.storeState.blockTemplate))
          this.storeState.block.uuid = uuid
          this.storeState.block.set.type = 'explore'
          this.underlay = ''
          // if (this.storeState.setSourceId) {
          //   this.storeState.block.source.uuid = this.storeState.setSourceId
          //   this.storeState.setSourceId = false
          // } else if (!this.storeState.block.source.uuid) {
          //   this.storeState.block.source.uuid = this.storeState.defaultSource.block_uuid
          // }
          this.getSearchSuggestions({searchTerm: ''})
          this.updateUnderlayKeydown()
          this.getFilterSuggestions()
          this.storeState.gotBlock = true
          setTimeout(() => {
            this.$refs.searchText.focus()
          }, 0);
          this.getBlockHistory()
        } else {
          this.storeState.gotBlock = true
          this.storeState.noAccess = true
          console.log('you dont have access to this block')
        }
      } else if (!this.storeState.gotBlock) {
        setTimeout(() => {
            this.getBlock(uuid)
        }, 100);
      }
    },
    getJustThisBlock(blockId) {
      console.log('getJustThisBlock...')
      const path = store.getPath('/soup_get_block')
      let d = {
        sessionId: this.storeState.sessionId,
        blockId: blockId,
      }
      var self = this
      axios.post(path, d)
        .then((res) => {
          console.log('gotJustThisBlock: ')
          self.storeState.block = res.data.data
          self.storeState.gotBlock = true
          self.storeState.noAccess = false
        })
        .catch((error) => {
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    getBlockHistory(uuid) {
      let blockLs = Object.keys(this.storeState.blocks).map(id => this.storeState.blocks[id])
      blockLs = blockLs.sort((a, b) => a.viewOn - b.viewOn);
      this.storeState.blockHistory = blockLs.sort((a, b) => { return b.viewedOn - a.viewedOn}).slice(0, 10)
      console.log('this.storeState.blockHistory: ', this.storeState.blockHistory)
    },
    updateUnderlay(suggestion) {
      this.storeState.block.setQuery = this.storeState.block.setQuery.replace(this.storeState.searchTerm, '')
      this.storeState.block.setQuery += suggestion.path + '  '
      // let html = ''
      // html+= `<span class="term-underlay" data-uuid="${suggestion.suggestionUuid}">${suggestion.path}</span>`
      // this.underlay = html
      this.updateUnderlayKeydown()
    },
    updateUnderlayKeydown() {
      let searchTermParts = this.storeState.block.setQuery.split(/(\s+)/)
      this.storeState.searchTerm = ''
      let html = ''
      // this.storeState.block.setQueryThings = []
      let currentMatches = []
      for (let i = 0; i < searchTermParts.length; i++) {
        let term = searchTermParts[i];
        let termMatch = this.underlayTerms.find(t => t.path === term)
        if (termMatch) {
          html+= `<span class="term-underlay" data-uuid="${termMatch.suggestionUuid}">${termMatch.path}</span>`
          let alreadyMatched = this.storeState.block.setQueryThings.find(t => t.path === term)
          if (!alreadyMatched) {
            termMatch.selected = true
            this.storeState.block.setQueryThings.push(termMatch)
          }
          currentMatches.push(termMatch.path)
        } else {
          this.storeState.searchTerm += term
          html+= `<span class="term-underlay term-underlay-text">${term}</span>`
        }
      }
      this.storeState.block.setQueryThings = this.storeState.block.setQueryThings.filter(t => currentMatches.includes(t.path))
      if (this.storeState.block.setQueryThings.length > 0) {
        this.storeState.block.source = this.storeState.blocks[this.storeState.block.setQueryThings[0].uuid].source
      }
      this.storeState.searchTerm = this.storeState.searchTerm.replace(/\s+/g,' ').trim();
      this.underlay = html
    },
    rowClick(e) {
      console.log('rowClick: ', e)
      var self = this
      let suggestion = self.storeState.searchSuggestions[e.currentTarget.dataset.index]
      if (suggestion.type === 'snippet') {
        console.log('e.currentTarget.id: ', e.currentTarget.dataset.uuid)
        this.$parent.openBlock(e.currentTarget.dataset.uuid)
      } else {
        this.updateUnderlay(suggestion)
        let opts = {setQueryThings: this.storeState.block.setQueryThings, filters: this.storeState.block.set.filters}
        let sql = store.generateSetSql(opts)
        this.storeState.block.code = sql
        this.storeState.block.usingSet = true
        this.storeState.block.set.type = 'explore'
        this.showSuggestions = false
        this.storeState.searchSuggestions = []
        this.$forceUpdate()
        // store.runSet({})
      }
    },
    getFromNow: function (row) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${row.email}`]
      if (details && details.reminder) {
        let m = moment(details.reminder)
        return m.fromNow()
      } else {
        return ''
      }
    },
    getTags: function (row) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${row.email}`]
      if (details && details.tags) {
        return details.tags
      } else {
        return ''
      }
    },
    openSettings() {
      this.storeState.cmdkParentCmd = 'settings'
      this.$parent.openCmdK({cmdkParentCmd: 'settings', cmdkInput: ''})
    },
    newBlock() {
      let blockId = store.uuidv4()
      this.storeState.newBlocks.push(blockId)
      console.log('newBlocks: ', this.storeState.newBlocks)
      this.$router.push({ name: 'Run', params: {id:  blockId}}).catch(err => console.error(err))
    },
    validateSearch(val) {
      console.log('val term: ', val)
      this.storeState.searchTerm = this.newTag
      if (val.startsWith('#')) return true
      return false
    },
    filterBlocks(opts) {
      var blockResults = []
      opts.searchTerm = opts.searchTerm.toLowerCase()
      for (const blockId in this.storeState.blocks) {
        let block = this.storeState.blocks[blockId]
        if (block.code.toLowerCase().includes(opts.searchTerm)) {
          blockResults.push(block)
        } else if (block.title.toLowerCase().includes(opts.searchTerm)) {
          blockResults.push(block)
        }
      }
      blockResults = blockResults.slice(0, 5)
      return blockResults.sort((a, b) => { return b.viewedOn - a.viewedOn;})
    },
    everyLetterMatch(searchTerm, searchIn) {
      searchIn = searchIn.toLowerCase()
      searchTerm = searchTerm.toLowerCase()
      var include = true
      var searchTermLen = searchTerm.length
      var matches = 0
      var startMatch = searchIn.startsWith(searchTerm)
      for (let i = 0; i < searchTerm.length; i++) {
          if (!searchIn.includes(searchTerm[i].toLowerCase())) {
            include = false
            break
          } else {
            matches++
            //this chops off where the last letter was found, this means search letters need to be 
            //the same order as the match, e.g. segev = segment.events, but segev != vesg
            searchIn = searchIn.slice(searchIn.indexOf(searchTerm[i].toLowerCase()))
          }
      }
      var ratio = (matches * startMatch) * 1.0 / searchTermLen
      return {include: include, matches: matches, ratio: ratio}
    },
    getAllFieldsForSet(set) {
      var self = this
      var setFields = JSON.parse(this.storeState.blocks[set.setJsonId].code).fields
      let fields = []
      for (let [key, value] of Object.entries(setFields)) {
        let f = value
        f.path = `${set.name}.${key}`
        f.name = `${key}`
        f.uuid = set.block_uuid
        f.setJsonId = set.setJsonId
        f.suggestionUuid = store.uuidv4()
        f.setType = 'field'
        fields.push(f)
      }
      return fields
    },
    getSearchSuggestions(opts) {
      var self = this
      this.showSuggestions = true
      this.storeState.searchSuggestions = []
      let numPerCategory = 3
      let sets = []
      let fields = []
      this.underlayTerms = []
      self.storeState.sets = []
      for (let [key, value] of Object.entries(self.storeState.blocks)) {
        if (value.set && value.set.type === 'sql') {
          let set = {
            name: value.title,
            block_uuid: key,
            db_type: 'set',
            type: 'set',
            setJsonId: value.set.json
          }
          self.storeState.sets.push(set)
        }
      }
      var uniqueSetsInSearch = []
      if (this.storeState.block.setQueryThings.length > 0) {
        var uniqueSetsInSearch = _.uniq(this.storeState.block.setQueryThings.map(t => t.set || t.name));
        for (let i = 0; i < this.storeState.block.setQueryThings.length; i++) {
          let thing = this.storeState.block.setQueryThings[i];
          uniqueSetsInSearch.push(thing.set || thing.name)
        }
        uniqueSetsInSearch = _.uniq(uniqueSetsInSearch);
      }
      for (let i = 0; i < this.storeState.sets.length; i++) {
        let set = this.storeState.sets[i];
        if (uniqueSetsInSearch.length > 0 && !uniqueSetsInSearch.includes(set.name)) continue 
        let jsonValid = false
        try {
          JSON.parse(this.storeState.blocks[set.setJsonId].code).fields
          jsonValid = true
        } catch (error) {
          jsonValid = false
        }
        if (!set.setJsonId || !jsonValid) {
          continue
        }
        //if the set isnt already in the search, remove it
        //need to update this when JOINs are added
        // if (uniqueSetsInSearch.includes(set.name)) continue 
        var setFields = JSON.parse(this.storeState.blocks[set.setJsonId].code).fields
        for (let [key, value] of Object.entries(setFields)) {
          let field = value
          field.path = `${set.name}.${key}`
          field.set = set.name
          field.name = `${key}`
          field.sql = `${value.sql || key}`
          field.uuid = set.block_uuid
          field.setJsonId = set.setJsonId
          field.suggestionUuid = store.uuidv4()
          field.setType = 'field'
          if (field.type === 'time') {
            var formatsToGet = ['YYYY-MM-DD', 'YYYY-MM-W', 'YYYY-MM', 'YYYY', 'raw']
            let formatNames = {'YYYY-MM-DD': 'Day', 'YYYY-MM-W': 'Week', 'YYYY-MM': 'Month', 'YYYY': 'Year', 'raw': 'Raw'}
            if (field.intervals && field.intervals.length > 0) {
              formatsToGet = field.intervals
            }
            field.title = field.label || field.name
            field.details = `${field.type} in ${field.path}`
            field.icon = this.storeState.iconLookUp[field.type]
            field.setType = 'field'
            for (let i3 = 0; i3 < formatsToGet.length; i3++) {
              let dateField = store.makeBlockSafe(field)
              let s = this.storeState.allSources.find(s => s.block_uuid === this.storeState.block.source.uuid)
              if (!s) continue
              dateField.sql = store.getSqlDateFormat(field.name, field.label, formatsToGet[i3], s.db_type).sqlNoLabel
              dateField.label = `${dateField.label} ${formatNames[formatsToGet[i3]]}`
              dateField.suggestionUuid = store.uuidv4()
              dateField.title = dateField.label
              dateField.path = `${dateField.set}.${dateField.name}_${formatNames[formatsToGet[i3]].toLowerCase()}`
              this.underlayTerms.push(dateField)
              fields.push(dateField)
            }
          } else {
            field.title = field.label || field.name
            field.details = `${field.type} in ${field.path}`
            field.icon = this.storeState.iconLookUp[field.type]
            field.setType = 'field'
            fields.push(field)
            this.underlayTerms.push(field)
          }
        }
        let match = this.everyLetterMatch(opts.searchTerm, set.name)
        set.details = `set`
        set.title = set.name
        set.path = set.name
        set.icon = 'mdi-table'
        set.uuid = set.block_uuid
        set.ratio = match.ratio
        set.suggestionUuid = store.uuidv4()
        set.setType = 'set'
        this.underlayTerms.push(set)
        if (match.include && !(uniqueSetsInSearch.includes(set.name))) {
          this.storeState.searchSuggestions.push(set)
        }
      }
      this.storeState.searchSuggestions = this.storeState.searchSuggestions.sort((a, b) => a.ratio - b.ratio);
      this.storeState.searchSuggestions = this.storeState.searchSuggestions.slice(0, 5)
      let fields2 = []
      for (let i2 = 0; i2 < fields.length; i2++) {
        let field = fields[i2];
        let match = this.everyLetterMatch(opts.searchTerm, field.label)
        let matchSpace = this.everyLetterMatch(opts.searchTerm, field.label)
        if (match.include || matchSpace.include) {
          field.ratio = match.ratio
          fields2.push(field)
        }
      }
      fields2 = fields2.sort((a, b) => a.ratio - b.ratio);
      this.storeState.searchSuggestions = this.storeState.searchSuggestions.concat(fields2).slice(0, 10)
      this.updateUnderlayKeydown()
    },
    getFilterSuggestions() {
      this.filterSuggestions = []
      let numPerCategory = 3
      let sets = []
      let fields = []
      var uniqueSetsInSearch = []
      if (this.storeState.block.setQueryThings.length > 0) {
        var uniqueSetsInSearch = _.uniq(_.map(this.storeState.block.setQueryThings, 'set'));
        for (let i = 0; i < this.storeState.block.setQueryThings.length; i++) {
          let thing = this.storeState.block.setQueryThings[i];
          uniqueSetsInSearch.push(thing.set || thing.name)
        }
        uniqueSetsInSearch = _.uniq(uniqueSetsInSearch);
      }
      for (let i = 0; i < this.storeState.sets.length; i++) {
        let set = this.storeState.sets[i];
        if (uniqueSetsInSearch.length > 0 && !uniqueSetsInSearch.includes(set.name)) continue 
        let jsonValid = false
        try {
          JSON.parse(this.storeState.blocks[set.setJsonId].code).fields
          jsonValid = true
        } catch (error) {
          jsonValid = false
        }
        if (!set.setJsonId || !jsonValid) {
          continue
        }
        var setFields = JSON.parse(this.storeState.blocks[set.setJsonId].code).fields
        for (let [key, value] of Object.entries(setFields)) {
          let f = value
          f.path = `${set.name}.${key}`
          f.name = `${key}`
          f.uuid = set.block_uuid
          f.setJsonId = set.setJsonId
          f.suggestionUuid = store.uuidv4()
          f.setType = 'field'
          fields.push(f)
        }
      }
      let fields2 = []
      for (let i2 = 0; i2 < fields.length; i2++) {
        let field = fields[i2];
        let match = {include: true, ratio: 1}
        if (match.include && !field.measure) {
          field.title = field.label || field.name
          field.details = `${field.type} in ${field.path}`
          field.ratio = match.ratio
          field.icon = this.storeState.iconLookUp[field.type]
          field.setType = 'field'
          this.filterSuggestions.push(field)
        }
      }
      this.filterSuggestions = this.filterSuggestions.sort((a, b) => b.ratio - a.ratio);
    },
    search(e) {
      var self = this
      if (![13, 40, 38].includes(e.keyCode)) this.storeState.searchIndex = 0
      console.log('search term: ', this.storeState.searchTerm, e)
      if ([13].includes(e.keyCode)) {
        // e.preventDefault() //already done in App.vue
        console.log('hit enter handleenter...')
        let suggestion = self.storeState.searchSuggestions[self.storeState.searchIndex]
        this.updateUnderlay(suggestion)
        this.updateUnderlayKeydown()
        let opts = {setQueryThings: this.storeState.block.setQueryThings, filters: this.storeState.block.set.filters}
        let sql = store.generateSetSql(opts)
        this.storeState.block.code = sql
        this.storeState.block.usingSet = true
        this.storeState.block.set.type = 'explore'
        this.showSuggestions = false
        this.storeState.searchSuggestions = []
        // store.runSet({})
        return
      }
      let opts = {searchTerm: this.storeState.searchTerm}
      this.getSearchSuggestions(opts)
      // this.filterBlocks(opts)
    },
    getPath(path) {
      if (window.location.hostname === 'localhost') {
        return `http://localhost:5000${path}`
      }
      return  `https://seekwell.io${path}`
    },
  },
  computed: {
    runTimes: function () {
      let mins = _.range(0, 59, 5)
      let hours = _.range(0, 23, 1)
      let times = []

      for (let i = 0; i < hours.length; i++) {
        let hour = hours[i];
        for (let i = 0; i < mins.length; i++) {
          times.push(`${_.padStart(hour, 2, '0')}:${_.padStart(mins[i], 2, '0')}`)
        }
      }
      return times
    },
    uniqueSources: function () {
      if (!this.storeState.block || !this.storeState.block.source) return []
      let result = []
      let uniqueNickNames = []
      if (this.storeState.block.source.uuid) {
        let curS = this.storeState.allSources.find(o => o.block_uuid === this.storeState.block.source.uuid)
        if (curS) {
          result.push(curS)
          uniqueNickNames.push(curS.name)
        }
      }
      for (let i = 0; i < this.storeState.allSources.length; i++) {
        let source = this.storeState.allSources[i]
        if (!uniqueNickNames.includes(source.name)) {
          uniqueNickNames.push(source.name)
          result.push(source)
        }
      }
      result = result.concat(this.storeState.sets)
      return result
    },
  },
  created() {
    store.updateBlock = debounce(store.updateBlock, 150)
    this.storeState.noAccess = false
    this.storeState.gotBlock = false
    // this.getJustThisBlock(this.$route.params.id)
    this.getBlock(this.$route.params.id)
  },
};
</script>

<style>
.active {
  background-color: #eee;
  border-left-color: #333;
  border-left-style: solid;
  border-left-width: 3px;
}
.searchResultRows {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 40px;
  padding-right: 30px;
}

.vue-input-tag-wrapper {
    background-color: #fff;
    border: none;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}

.vue-input-tag-wrapper .new-tag {
    background: transparent;
    border: none;
    color: #333;
    flex-grow: 1;
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 6px;
    margin-top: 1px;
    outline: none;
    padding: 0px;
}

.vue-input-tag-wrapper .input-tag {
    background-color: #eee;
    border: 1px solid #eee;
    border-radius: 2px;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}
.searchResults {
  margin-top: 20px;
  margin-left: 2px;
}
.searchInput {
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.dateContainer {
  width: 180px;
  padding-top: 30px;
}
.amount {
  width: 180px;
  /* width: 100%; */
}
.padded {
  padding: 20px;
}
.btn-pad {
  margin: 20px;
}
.search-input-container {
  padding-bottom: 20px;
  padding-left: 40px;
}
.row-sub-title {
  color: #ccc;
  padding-left: 10px;
}
.row-reminder {
  color: rgb(46, 170, 220);
  padding-left: 10px;
}
.save-search-q {
  float: right;
  margin-top: -35px;
  margin-right: 26px;
}
.block-search {
  float: right;
  margin-top: -35px;
  margin-right: 3px;
}

.search-container2 {
  padding-top: 20px;
  margin-left: 40px;
  margin-bottom: 20px;
}
.term-underlay {
  /* margin-left: 8px; */
  /* margin-top: 1px; */
  background: rgba(84, 172, 220, 0.2);
  box-shadow: 0 0 0 2px rgba(84, 172, 220, 0.2);
  opacity: 0.5;
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
  white-space: pre;
}
.term-underlay-text {
  /* margin-left: 0px; */
  background: transparent;
  box-shadow: none;
  opacity: 0.5;
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.term-underlay-partial {
  /* margin-left: 0px; */
  background: rgba(249, 150, 255, 0.2);
  box-shadow: none;
}
.search-underlay {
  position: absolute;
  width: 100%;
}
.search-text-container {
  position: absolute;
  width: 100%;
  height: 38px;
  font-size: 20px;
  outline: none;
}
#soupSearchContainer {
  display: -webkit-inline-box;
  position: absolute;
  width: 100%;
  margin-left: 20px;
}
.soup-queue-container {
  margin-left: 0px;
  margin-top: 15px;
  margin-bottom: 20px;
}
.row-title {
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row-pic {
  display: inline;
}
.row-code {
  color: rgba(0, 0, 0, 0.5);
  /* display: inline; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row-last-run {
  color: rgba(0, 0, 0, 0.5);
  float: right;
}
.block-icons {
  float: right;
}
.blocks-icon {
}
.sw-button {
  height: 40px;
  display: inline-block;
  line-height: 40px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: "Rubik";
  border-radius: 4px;
  text-align: center;
  background: #19774d;
  border: solid 1px #19774d;
  color: white;
  font-size: 0.875rem;
  text-decoration: none;
  padding: 0 1.5rem;
  transition: background-color 0.3s, border-color 0.3s, color 0.3s;
  cursor: pointer;
}
.sw-button:hover {
  background-color: #50a779;
  border-color: #50a779;
}
.v-tab {
  min-width: 0px !important;
  padding-right: 46px !important;
  font-size: 20px !important;
  text-transform: none !important;
}
.left {
  float: left;
}
.nopad {
  padding-bottom: 0px !important;
  padding-top: 8px !important;
}
.favorite {
  padding-right: 10px !important;
  margin-top: 1px;
}
.search-suggestions {
  padding-top: 50px;
}
.dense-col {
  padding-left: 0px;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  color: rgba(0, 0, 0, 0.5);
  /* display: inline; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.suggestion-icons {
  color: rgba(0, 0, 0, 0.5) !important;
  margin-top: 2px;
  padding-right: 5px !important;
}
.suggest-explain {
  padding-left: 40px;
}
.suggest-title {
  padding-left: 8px;
}
.io-split-container {
  margin-top: 40px;
  /* height: 50px; */
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
}
.split-elements {
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 28px;
}
.split-elements-right {
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 28px;
}
.split-element {
  display: inline-block;
  padding-right: 40px;
  cursor: pointer;
  font-weight: 700;
}
.split-element-right {
  display: inline-block;
  padding-right: 40px;
  font-weight: 700;
  float: right;
}
.search-table-container {
  padding-top: 0px;
}
.fetching-msg-code {
  /* background: #F5F7FA; */
  color: #666;
  padding: 5px;
  font-family: monospace;
  display: inline;
  word-wrap: break-word;
}
.dot-pulse {
  position: relative;
  display: inline-block;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #212529;
  color: #212529;
  box-shadow: 9999px 0 0 -5px #212529;
  animation: dotPulse 1.5s infinite linear;
  animation-delay: .25s;
}

.dot-pulse::before, .dot-pulse::after {
  content: '';
  display: inline-block;
  position: absolute;
  top: 0;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #212529;
  color: #212529;
}

.dot-pulse::before {
  box-shadow: 9984px 0 0 -5px #212529;
  animation: dotPulseBefore 1.5s infinite linear;
  animation-delay: 0s;
}

.dot-pulse::after {
  box-shadow: 10014px 0 0 -5px #212529;
  animation: dotPulseAfter 1.5s infinite linear;
  animation-delay: .5s;
}

@keyframes dotPulseBefore {
  0% {
    box-shadow: 9984px 0 0 -5px #212529;
  }
  30% {
    box-shadow: 9984px 0 0 2px #212529;
  }
  60%,
  100% {
    box-shadow: 9984px 0 0 -5px #212529;
  }
}

@keyframes dotPulse {
  0% {
    box-shadow: 9999px 0 0 -5px #212529;
  }
  30% {
    box-shadow: 9999px 0 0 2px #212529;
  }
  60%,
  100% {
    box-shadow: 9999px 0 0 -5px #212529;
  }
}

@keyframes dotPulseAfter {
  0% {
    box-shadow: 10014px 0 0 -5px #212529;
  }
  30% {
    box-shadow: 10014px 0 0 2px #212529;
  }
  60%,
  100% {
    box-shadow: 10014px 0 0 -5px #212529;
  }
}
.dot-pulse-container {
  display: inline-block;
  margin-right: 30px;
  margin-left: 30px;
}
.v-select__selections {
  padding-left: 10px;
}
.chart-option-label {
  padding-left: 1em;
}
.sw-strong {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: #000000;
}
.viz-row:hover {
  background-color: #F5F7FA;
}
.row-highlight:hover {
  background-color: #F5F7FA;
}
.viz-selected {
  font-weight: bold;
}
.chart-title {
  font-size: 24px;
  font-weight: 700;
  width: 100%;
  padding-right: 10px;
}
.filter-row {
  margin-left: 0px;
  margin-right: 0px;
  padding-left: 1em;
  padding-top: .5em;
  padding-bottom: .5em;
}
.link-color {
  color: rgb(46, 170, 220);
}
.sw-button-plain {
  background: #FFFFFF;
  border: 1px solid #CBD2D9;
  box-sizing: border-box;
  border-radius: 3px;
}
.inline {
  display: inline;
}
</style>